<div class="card">
  <app-custom-grid *ngIf="!ready"  [gridColConfig]="options" (onActionBegin)="actionBeginAction($event)" (onSwitchChange)="setState($event)" [pageSettings]="pageSettings"
  [template]="tryTest" (onButtonClick)="btnClick($event)" [paging]="true" [tableOptions]="gridOptions" (onDataSourceChange)="dataChange($event)"
><ng-template #tryTest>
  <ejs-tooltip id="newTool" target="#newUser" content="Aggiungi un nuovo contratto">
      <button ejs-button id="newUser" (click)="add()" class="e-flat e-flat-add ml-3 e-btn"><i class="e-icons e-add"></i></button>
  </ejs-tooltip>
</ng-template>
</app-custom-grid>
</div>
